import React from "react";
import styled from "styled-components";

const PrivacyContainer = styled.div`
    min-height: 100vh;
    background: white;
    padding: 4rem 0;
`;

const PrivacyContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;

    @media (max-width: 768px) {
        padding: 0 15px;
    }
`;

const PrivacyTitle = styled.h1`
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #333;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }
`;

const PrivacySection = styled.section`
    margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 1rem;
    color: #333;

    @media (max-width: 768px) {
        font-size: 1.3rem;
    }
`;

const SectionContent = styled.div`
    line-height: 1.8;
    color: #666;
    font-size: 1rem;

    @media (max-width: 768px) {
        font-size: 0.9rem;
        line-height: 1.6;
    }
`;

const Privacy: React.FC = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <PrivacyContainer>
            <PrivacyContent>
                <PrivacyTitle>개인정보처리방침</PrivacyTitle>

                <PrivacySection>
                    <SectionTitle>1. 개인정보의 처리 목적</SectionTitle>
                    <SectionContent>
                        NO-ON(이하 "회사")은 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.
                        <br />
                        <br />
                        1) 서비스 제공 및 운영
                        <br />
                        2) 고객 상담 및 문의 응대
                        <br />
                        3) 서비스 개선 및 신규 서비스 개발
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>2. 개인정보의 처리 및 보유기간</SectionTitle>
                    <SectionContent>
                        회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
                        <br />
                        <br />
                        서비스 이용기간 동안 개인정보를 보유하며, 서비스 이용 종료 시 즉시 파기합니다.
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>3. 개인정보의 제3자 제공</SectionTitle>
                    <SectionContent>
                        회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>4. 개인정보처리의 위탁</SectionTitle>
                    <SectionContent>
                        회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
                        <br />
                        <br />
                        현재 위탁하고 있는 업무는 없습니다.
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>5. 정보주체의 권리·의무 및 그 행사방법</SectionTitle>
                    <SectionContent>
                        이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
                        <br />
                        <br />
                        1) 개인정보 열람요구
                        <br />
                        2) 오류 등이 있을 경우 정정 요구
                        <br />
                        3) 삭제요구
                        <br />
                        4) 처리정지 요구
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>6. 개인정보의 파기</SectionTitle>
                    <SectionContent>
                        회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
                        <br />
                        <br />
                        전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>7. 개인정보의 안전성 확보 조치</SectionTitle>
                    <SectionContent>
                        회사는 개인정보보호법 제29조에 따라 다음과 같은 안전성 확보 조치를 취하고 있습니다.
                        <br />
                        <br />
                        1) 개인정보의 암호화
                        <br />
                        2) 해킹 등에 대비한 기술적 대책
                        <br />
                        3) 개인정보에 대한 접근 제한
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>8. 개인정보 보호책임자</SectionTitle>
                    <SectionContent>
                        회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                        <br />
                        <br />
                        ▶ 개인정보 보호책임자
                        <br />
                        성명: NO-ON
                        <br />
                        연락처: contact@noon.com
                    </SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>9. 개인정보처리방침의 변경</SectionTitle>
                    <SectionContent>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</SectionContent>
                </PrivacySection>

                <PrivacySection>
                    <SectionTitle>부칙</SectionTitle>
                    <SectionContent>이 개인정보처리방침은 2024년 1월 1일부터 시행합니다.</SectionContent>
                </PrivacySection>
            </PrivacyContent>
        </PrivacyContainer>
    );
};

export default Privacy;
